export default __webpack_public_path__ + "static/media/FT_CFM5.77fa5507.pdf";